// extracted by mini-css-extract-plugin
export default {"text":"PaymentFields_text__RMKoL"};